'use client';

import { useCallback } from 'react';
import { UnifiedSwapClient, SwapClientType } from '@velocity-exchange/sdk';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { GLOBAL_SETTINGS_CLIENT } from 'src/providers/settingsProvider';
import { createSwapClient } from 'src/utils/swap';

/**
 * Hook for managing the swap client.
 */
export const useSwapClient = () => {
	const connection = useDriftStore((s) => s.connection.current);
	const setSwapClientInStore = useDriftStore((s) => s.set);

	/**
	 * Sets a specific swap client instance
	 */
	const setSwapClient = useCallback(
		(swapClient: UnifiedSwapClient) => {
			setSwapClientInStore((s) => {
				s.swapClient = swapClient;
			});
		},
		[setSwapClientInStore]
	);

	/**
	 * Updates the swap client based on current settings
	 */
	const updateSwapClient = useCallback(() => {
		if (!connection) return;

		const clientType: SwapClientType =
			GLOBAL_SETTINGS_CLIENT?.overallSettingsState?.swapClientType ?? 'titan';

		setSwapClient(createSwapClient({ clientType, connection }));
	}, [connection, setSwapClient]);

	return { updateSwapClient, setSwapClient };
};
